import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAuditLogs = async (filters = {}, page = 0, size = 50) => {
  try {
    const params = {
      page,
      size,
      ...(filters.userId && { userId: filters.userId }),
      ...(filters.initialDate && { initialDate: filters.initialDate }),
      ...(filters.finalDate && { finalDate: filters.finalDate }),
    };

    const response = await api.get('/audit-log', {
      params,
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar logs.');
  }
};

